<template>
  <div class="projects">
    <div
      v-for="(project, i) in softwareProjects"
      :key="i"
      class="project"
      data-aos="zoom-in"
    >
      <div class="type">
        <p class="type-text">{{ project.type }}</p>
      </div>
      <div>
        <div class="image-div">
          <img class="image" :src="project.image">
        </div>
        <div class="text-div">
          <h2 class="title">{{ project.title }}</h2>
          <p class="description">{{ project.description }}</p>
          <span
            class="stack" v-for="(tool, j) in project.stack"
            :key="j"
          >{{ tool }}</span>
        </div>
        <button
          class="details"
          v-on:click="$store.commit('viewProjectDetails', project)"
        >Details</button>
      </div>
    </div>
  </div>
</template>

<script>
import { softwareProjects } from '../../../../data.js'
export default {
  data() {
    return {
      softwareProjects: softwareProjects
    }
  }
}
</script>

<style scoped>
.projects {
  display: flex;
  flex-wrap: wrap;
}
.project {
  flex-basis: 250px;
  height: 375px;
  margin: 0 35px 35px 0;
  padding: 10px;
  background: white;
  text-align: left;
  box-shadow: 1px 2px 8px 0px grey;
  transition: .3s;
}
.type {
  transform: translateY(-10px);
  position: absolute;
  right: 0;
}
.type-text {
  padding: 5px;
  margin: 0;
  font-weight: 500;
  font-size: 12px;
  border-bottom-left-radius: 5px;
  background: rgba(36, 36, 36, 0.5);
  color: white;
}
.image-div {
  height: 150px;
  background: var(--light-grey);
  overflow: hidden;
  margin-bottom: 10px;
}
.image {
  width: 100%;
  min-height: 100%;
}
.text-div {
  padding: 0 5px 10px 5px;
}
.title {
  margin: 0;
  font-size: 24px;
}
.description {
  margin: 0 0 15px 0;
  font-size: 14px;
  color: grey;
}
.stack {
  margin: 0 5px 5px 0;
  display: inline-block;
  background: lightgrey;
  color: rgb(34, 34, 34);
  font-size: 12px;
  border-radius: 20px;
  padding: 3px 8px;
}
.details {
  display: block;
  border: 0;
  border-radius: 5px;
  padding: 10px;
  background: steelblue;
  color: white;
  font-weight: 700;
  font-size: 18px;
  width: calc(100% - 20px);
  bottom: 0;
  position: absolute;
  margin: 10px auto;
}
.project:hover {
  transform: scale(1.05);
  transition: .3s;
}
.details:hover {
  background: coral;
  cursor: pointer;
  transition: .3s;
}
@media (min-width: 951px) {
  .project:nth-child(3n + 3) {
    margin-right: 0;
  }
}
@media (max-width: 950px) and (min-width: 615px) {
  .project:nth-child(even) {
    margin-right: 0;
  }
  .projects {
    width: 580px;
    margin: auto;
  }
}
@media (max-width: 614px) {
  .projects {
    width: 270px;
    margin: auto;
  }
  .project {
    display: block;
    margin-bottom: 35px;
    margin-right: 0;
  }
}
</style>
